<template>
  <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
    <v-row>
      <v-col cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Location ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.locationID"
            label="Location ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Contact Name"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.contactName"
            label="Contact Name"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Contact Number"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.phoneNumber"
            label="Contact Number"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Contact Notes"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.notes"
            label="Contact Notes"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="SiteAccess Special Conditions"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.siteAccessSpecialConditions"
            label="SiteAccess Special Conditions"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="SiteAccess Notes"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.siteAccessNotes"
            label="SiteAccess Notes"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Appointment Sla"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-combobox
            :items="appointmentSla"
            label="Appointment Sla"
            outlined
            placeholder=" "
            :clearable="true"
            v-model="appointment.appointmentSla"
            :error-messages="errors"
            dense
            :readonly="false"
          ></v-combobox>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Appointment Slot Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-combobox
            :items="appointmentSlotType"
            label="Appointment Slot Type"
            outlined
            placeholder=" "
            :clearable="true"
            v-model="appointment.appointmentSlotType"
            :error-messages="errors"
            dense
            :readonly="false"
          ></v-combobox>
        </ValidationProvider>
      </v-col>

<!--      <v-col-->
<!--        cols="12"-->
<!--        :md="'6'"-->
<!--        class="pt-0 pb-1"-->
<!--      >-->
<!--        <ValidationProvider-->
<!--          name="Appointment Time Range"-->
<!--          :rules="'required'"-->
<!--          v-slot="{ errors }"-->
<!--        >-->
<!--          <v-combobox-->
<!--            :items="appointmentTimeRange"-->
<!--            label="Appointment Time Range"-->
<!--            outlined-->
<!--            placeholder=" "-->
<!--            :clearable="true"-->
<!--            v-model="appointment.appointmentTimeRange"-->
<!--            :error-messages="errors"-->
<!--            dense-->
<!--            :readonly="false"-->
<!--          ></v-combobox>-->
<!--        </ValidationProvider>-->
<!--      </v-col>-->

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Demand Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-combobox
            :items="demandType"
            label="Demand Type"
            outlined
            placeholder=" "
            :clearable="true"
            v-model="appointment.demandType"
            :error-messages="errors"
            dense
            :readonly="false"
          ></v-combobox>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
        v-if="isNonEUJumperOnly"
      >
        <ValidationProvider
          name="CPI ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="appointment.cpiId"
            label="CPI ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="'6'"
        class="pt-0 pb-1"
        v-if="businessOptionEnabled"
      >
        <ValidationProvider
          name="End User Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-combobox
            :items="endUserType"
            label="End User Type"
            outlined
            placeholder=" "
            :clearable="true"
            v-model="appointment.endUserType"
            :error-messages="errors"
            dense
            :readonly="false"
          ></v-combobox>
        </ValidationProvider>
      </v-col>


      <v-col cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Slot Date Time"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <date-picker v-model="appointment.dateTimeRange" type="datetime" range placeholder="Select Appointment datetime range"></date-picker>
        </ValidationProvider>
      </v-col>

      <v-col v-if="showSlots" cols="12" :md="'6'" class="pt-0 pb-1">
        <v-card  class="pb-4">
          <v-card-title class="primary">
            <span class="white--text">Query results</span>
          </v-card-title>

          <div>
            <b>Available Slots:</b>

            <v-radio-group v-model="appointment.dateGroup" class="mt-0 pl-3 slot-list">
              <v-radio
                v-for="slot in availableNbnSlots"
                :key="slot.validFor.startDateTime"
                :label="slot.validFor.startDateTime | formatDateTime(true)"
                :value="slot"
              ></v-radio>
            </v-radio-group>
          </div>

        </v-card>
      </v-col>

      <v-divider></v-divider>

      <v-col cols="12" :md="'12'" class="pt-0 pb-1">
        <div class="mb-7">
          <v-btn
            class="primary"
            @click="submit"
          >Query</v-btn
          >
        </div>
      </v-col>



    </v-row>

  </ValidationObserver>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "nbn-appointment-details",
  components: { DatePicker },
  props: {
    appointment: { type: Object },
    businessOptionEnabled: {type: Boolean}
  },
  data: () => ({
    appointmentSla:[
      { text: "Standard", value: "Standard", disabled: false },
      { text: "Accelerated", value: "Accelerated", disabled: false },
    ],
    demandType:[
      { text: "Standard Install", value: "Standard Install", disabled: false },
      // { text: "Additional Install", value: "Additional Install", disabled: false },
      { text: "Non EU Jumper Only", value: "Non EU Jumper Only", disabled: false },
      { text: "Service Restoration", value: "Service Restoration", disabled: false },
    ],
    appointmentSlotType:[
      { text: "AM", value: "AM", disabled: false },
      { text: "PM", value: "PM", disabled: false },
      { text: "AHA", value: "AHA", disabled: false },
    ],
    appointmentTimeRange:[
      { text: "8:00 - 12:00", value: "AM", disabled: false },
      { text: "13:00 - 17:00", value: "PM", disabled: false },
      { text: "7:00 - 14:00", value: "AHA", disabled: false },
    ],
    endUserType:[
      { text: "Residential", value: "Residential", disabled: false },
      { text: "Business", value: "Business", disabled: false },
    ],
    showSlots:false,
    availableNbnSlots:[],
    dateGroup: null,
  }),
  methods:{
    submit(){
      let vm = this;
      let payload = {};

      payload = {
        locationId:vm.appointment.locationID,
        demandType:vm.appointment.demandType.value,
        priId:null,
        alternativeTechnology:null,
        appointmentId:null,
        copperPairId:null,
        appointmentSlotType:vm.appointment.appointmentSlotType.value,
        priorityAssist:"No",
        // serviceRestorationSLA:null,
        nBNReferenceID:null,
        startDateTime:vm.appointment.dateTimeRange[0],
        endDateTime:vm.appointment.dateTimeRange[1],
        endUserType:(vm.appointment.endUserType === null || vm.appointment.endUserType === undefined || vm.appointment.endUserType ==="")?"Residential":vm.appointment.endUserType.value
      };

      if(payload.demandType !== "Service Restoration")
      {
        payload.appointmentSLA = "Standard";
      } else {
        payload.serviceRestorationSLA = "Standard";
      }

      vm.checkNbnAvailableSlots(payload).then((data) => {
        vm.availableNbnSlots = data.data.availableTimeSlot;
        vm.$emit("showSlotsResultSection", data);
        vm.showSlots = true;
        vm.$emit("isQueried");
      });
    }
  },
  computed: {
    isNonEUJumperOnly() {
      let vm = this;
      if(vm.appointment.demandType != null && vm.appointment.demandType.value === "Non EU Jumper Only")
      {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped>
.slot-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>

